/**
 * AI 聚合平台配置（仅 API 地址 + 鉴权）
 * 新增平台：在此增加一项，并在 .env 中配置对应 VUE_APP_ 变量
 */

export const AI_PROVIDERS = [
  {
    id: 'pollo',
    name: 'Pollo',
    baseURL: process.env.VUE_APP_AI_POLLO_BASE_URL || 'https://pollo.ai/api/platform',
    /** Pollo 使用 x-api-key，不用 Authorization */
    getHeaders: function () {
      var key = process.env.VUE_APP_AI_POLLO_API_KEY || ''
      return key ? { 'x-api-key': key } : {}
    }
  },
  {
    id: 'allall',
    name: 'AllAll',
    baseURL: process.env.VUE_APP_AI_ALLALL_BASE_URL || 'https://api.allall.ai',
    getAuthorization: function () {
      return process.env.VUE_APP_AI_ALLALL_API_KEY_NEW ? 'Bearer ' + process.env.VUE_APP_AI_ALLALL_API_KEY_NEW : ''
    }
  }
]

/** 逻辑模型使用哪家实现，直接改下面配置：pollo | allall（仅图生时 allall 生效，文生始终 pollo） */
export const LOGICAL_MODEL_PROVIDER = {
  'veo-3': 'pollo',
  'veo-3-1': 'pollo',
  'sora-2': 'pollo',
  'wan-2-5': 'pollo'
}

export function getLogicalModelProvider(logicalModelId) {
  return LOGICAL_MODEL_PROVIDER[logicalModelId] || null
}

/** 当前使用的平台 id，由环境变量指定，默认取第一个 */
export const CURRENT_PROVIDER_ID = process.env.VUE_APP_AI_PROVIDER || (AI_PROVIDERS[0] && AI_PROVIDERS[0].id) || ''

/** 模型 -> 平台 + 路径 */
export const AI_MODEL_PATHS = {
  'seedance-1-5-pro': { providerId: 'pollo', path: '/generation/bytedance/seedance-1-5-pro' },
  'wan-2-2-plus': { providerId: 'pollo', path: '/generation/wanx/wan-v2-2-plus' },
  'wan-2-5-preview': { providerId: 'pollo', path: '/generation/wanx/wan-v2-5-preview' },
  'wan-2-6': { providerId: 'pollo', path: '/generation/wanx/wan-v2-6' },
  'kling-v2-5-turbo': { providerId: 'pollo', path: '/generation/kling-ai/kling-v2-5-turbo' },
  'kling-v2-6': { providerId: 'pollo', path: '/generation/kling-ai/kling-v2-6' },
  'sora-2-pollo': { providerId: 'pollo', path: '/generation/sora/sora-2' },
  'minimax-hailuo-2-3': { providerId: 'pollo', path: '/generation/minimax/minimax-hailuo-2.3' },
  'veo-3-pollo': { providerId: 'pollo', path: '/generation/google/veo3' },
  'runway-gen-4-turbo': { providerId: 'pollo', path: '/generation/runway/runway-gen-4-turbo' },
  'veo-3-1': { providerId: 'pollo', path: '/generation/google/veo3-1' },
  'veo-3-1-fast': { providerId: 'pollo', path: '/generation/google/veo3-1-fast' },
  'wan-v2-2-flash': { providerId: 'pollo', path: '/generation/wanx/wan-v2-2-flash' },
  'vidu-q3-pro': { providerId: 'pollo', path: '/generation/vidu/viduq3-pro' }
}

export function getProviderById(id) {
  return AI_PROVIDERS.find(p => p.id === id) || null
}

export function getCurrentProvider() {
  return getProviderById(CURRENT_PROVIDER_ID) || AI_PROVIDERS[0] || null
}

/** AllAll 图片模型（同步接口 POST /v1/images/generations，无轮询） */
export const AI_IMAGE_MODELS_ALLALL = ['flux-kontext-max', 'flux-kontext-pro', 'flux-pro-1.1-ultra', 'flux-schnell', 'seedream-4-0', 'seedream-4']

export function getModelPath(modelId) {
  return AI_MODEL_PATHS[modelId] || null
}

export function isAllallImageModel(modelId) {
  return AI_IMAGE_MODELS_ALLALL.indexOf(modelId) !== -1
}

/** AllAll 音频 TTS 模型（同步接口 POST /v1/audio/speech，无轮询） */
export const AI_AUDIO_MODELS_ALLALL = ['speech-2.6-hd']

/** AllAll 音乐模型（异步 POST /suno/submit/music，需轮询） */
export const AI_MUSIC_MODELS_ALLALL = ['suno-music']

export function isAllallAudioModel(modelId) {
  return AI_AUDIO_MODELS_ALLALL.indexOf(modelId) !== -1
}

export function isAllallMusicModel(modelId) {
  return AI_MUSIC_MODELS_ALLALL.indexOf(modelId) !== -1
}
